import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-premium';
import { baseCell, dateCell } from 'components/cells';
import { filterOperators, dateFilterOperators } from 'components/enhanced';
import CustomizedSteppers from 'components/ui/data-display/RequestStatus';
import SectionTitle from 'components/ui/typography/SectionTitle';
import { IPurchaseRequest } from 'features/inventory/purchase-requests/types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export function PurchaseAutomaticLineColumns(): GridColDef[] {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const translationPrefix = 'pages.purchase-requests.list';

  const columns: GridColDef[] = [
    {
      field: 'id',
      headerName: t('entities.purchase-request.ID'),
      width: 200,
      renderCell: (params: GridRenderCellParams) => {
        const pr = params.row as IPurchaseRequest;
        return (
          <a onClick={() => navigate(`view/${params.row.id}`)}>
            <SectionTitle>
              {t(`${translationPrefix}.request-description`, { id: pr.id })}
            </SectionTitle>
          </a>
        );
      }
    },
    {
      field: 'created_by',
      width: 100,
      headerName: t('entities.purchase-request.proposer'),
      filterOperators
    },
    {
      field: 'warehouse',
      width: 250,
      headerName: t('entities.purchase-request.warehouse'),
      filterOperators,
      renderCell: baseCell
    },
    {
      field: 'created_at',
      width: 200,
      headerName: t('entities.purchase-request.created_at'),
      filterOperators: dateFilterOperators,
      renderCell: dateCell
    },
    {
      field: 'status',
      width: 200,
      headerName: t('entities.purchase-request.status'),
      filterable: false,
      renderCell: (props: GridRenderCellParams) => {
        const pr = props.row as IPurchaseRequest;
        return (
          <div className="w-full flex flex-row justify-end items-center">
            <div className="w-60">
              <CustomizedSteppers status={pr.status}></CustomizedSteppers>
            </div>
          </div>
        );
      }
    }
  ];
  return columns;
}
